import { createIcon } from '@chakra-ui/react';

/** Stripe's "S" mark on its blurple tile, for the places a sales channel is named. */
const StripeIcon = createIcon({
  displayName: 'StripeIcon',
  path: (
    <g>
      <rect width="28" height="28" rx="6" fill="#635BFF" />
      <path
        d="M13.3 11.2c0-.7.6-1 1.5-1 1.4 0 3.1.4 4.5 1.2V7.2a12 12 0 0 0-4.5-.8c-3.7 0-6.1 1.9-6.1 5.1 0 5 6.9 4.2 6.9 6.4 0 .8-.7 1.1-1.7 1.1-1.5 0-3.4-.6-4.9-1.4v4.3c1.7.7 3.3 1 4.9 1 3.8 0 6.4-1.9 6.4-5.1 0-5.4-7-4.5-7-6.4Z"
        fill="#FFFFFF"
      />
    </g>
  ),
  viewBox: '0 0 28 28',
});

export default StripeIcon;
